import { EMPTY_USER_GROUP_MODEL } from "presentation/model/UserGroup/UserGroupModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: UserGroupProvider,
    useTracked: useUserGroupTracked
} = createContainer(() => useState(EMPTY_USER_GROUP_MODEL), {concurrentMode: true});
export {UserGroupProvider, useUserGroupTracked};